import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { AcceptInvite } from "./routes/AcceptInvite";
import { AppShell } from "./routes/AppShell";
import { Apps } from "./routes/Apps";
import { Billing } from "./routes/Billing";
import { Login } from "./routes/Login";
import { Overview } from "./routes/Overview";
import { Team } from "./routes/Team";

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Login />} />
          <Route path="/accept-invite" element={<AcceptInvite />} />
          <Route element={<AppShell />}>
            <Route path="/" element={<Overview />} />
            <Route path="/apps" element={<Apps />} />
            <Route path="/team" element={<Team />} />
            <Route path="/billing" element={<Billing />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
